import ky from 'ky-universal';
import { parse } from 'query-string';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import { TRACKING_EVENT__PAGE_VIEW, TRACKING_OPERATION__SYSCTL, TRACKING_API_ENDPOINT } from '../../../constants';

/**
 * 傳送 pageview 事件：
 * 先延長或建立新的 session，
 * 將 session ID 及 metadata 傳送到後端。
 */
async function sendPageView(op_meta) {
  await extendOrInitSession();

  /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=401880768} */
  const payload = {
    ...getGeneralFields(),
    event: TRACKING_EVENT__PAGE_VIEW,
    op: TRACKING_OPERATION__SYSCTL,
    op_meta: op_meta || parse(location.search),
  };

  await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
}

import schedulePendingTasks from '../schedulePendingTasks';

export default (...args) => schedulePendingTasks(
  () => sendPageView(...args)
);
